import React, { useEffect, useRef, useState } from "react";
import styles from "./PopularProducts.module.css";
import { useDispatch, useSelector } from "react-redux";
import useHeroAPI from "../../../api/useHeroAPI";
import useProductsAPI from "../../../api/useProductsAPI";
import { setTabIndex } from "../../../redux/tabIndexSlice";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../../app/store";
import { MdArrowForward } from "react-icons/md";
import ProductGrid from "../ProductGrid/ProductGrid";
import { Product } from "../ProductCard/ProductCard";
import { selectRefreshTrigger } from "../../../redux/productSlice";
import AppSkeleton from "../../AppSkeleton/AppSkeleton";

interface PopularProductsProps {
  code?: string;
  title?: string;
  showViewAll?: boolean;
  entityType?: "POPULAR" | null;
  categoryId?: number | null;
}

const mapToProduct = (item: any): Product => ({
  product_id: item.product_id,
  brand: {
    name: item.brand?.name ?? "",
    field1:
      item.brand?.field1 ?? item.brand?.thumbnail ?? item.brand?.url ?? "",
  },
  name: item.product_name,
  product_name: item.product_name,
  product_offer_price: item.product_offer_price ?? 0,
  product_price: item.product_price ?? 0,
  rating: item.reviews_rating ?? 0,
  reviewCount: item.reviews_count ?? 0,
  compatible_vehicles: item.compatible_vehicles ?? "",
  document_as_product: item.document_as_product ?? [],
  image:
    item.document_as_product?.[0]?.document?.file_path ??
    "https://via.placeholder.com/300x200?text=No+Image",
  product_feature: item.product_feature ?? [],
  is_goto: item.is_goto ?? false,
  is_wishlist: item.is_wishlist ?? false,
  cart_item_id: item.cart_item_id ?? null,
});

export default function PopularProducts({
  code = "TYRE",
  title = "Popular Products",
  showViewAll = true,
  entityType,
  categoryId = null,
}: PopularProductsProps) {
  const tabIndex = useSelector((state: RootState) => state.tabIndex);
  const refreshTrigger = useSelector(selectRefreshTrigger);
  const [tyreType, setTyreType] = useState<any>(null);
  const [productLoading, setProductLoading] = useState(false);
  const [selectCategory, setSelectCategory] = useState<string>("");
  const [popularProductsArray, setPopularProductsArray] = useState<Product[]>(
    [],
  );
  const [userId, setUserId] = useState<any>(null);
  const [productType, setProductType] = useState<any>(null);
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);
  const [loader, setLoader] = useState(false);
  const [typesPreDefinedState, setTypesPreDefinedState] = useState<any[]>([]);

  const { predefinedFunc } = useHeroAPI();
  const { getProductList } = useProductsAPI();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const basePath = process.env.REACT_APP_BASE_PATH ?? "/";
  const requestIdRef = useRef(0);
  const fetchPredefined = async (categoryParentID: any) => {
    const predefinedResponse = await predefinedFunc({
      entity_type: "CATEGORY",
      categoryParentID: categoryParentID,
    });

    // console.log('llllllllllllll', predefinedResponse);

    if (predefinedResponse.status === 200) {
      const categories = predefinedResponse?.data?.data || [];

      setTypesPreDefinedState(categories);

      // Only Accessories needs category selection
      // if (code === "ACCESSORIES") {
      //   const defaultCategory = categories[0];

      //   setSelectedCategory(defaultCategory?.predefined_id ?? null);

      //   return defaultCategory;
      // }

      return "ALL";
    }

    return "ALL";
  };
  // const fetchPredefined = async () => {
  //   const predefinedResponse = await predefinedFunc({
  //     entity_type: "CATEGORY",
  //     categoryParentID: 8553,
  //   });

  //   if (predefinedResponse.status === 200) {
  //     const categories = predefinedResponse?.data?.data || [];
  //     setTypesPreDefinedState(categories);

  //     const defaultCategory = categories.find(
  //       (item: any) => item.code === "TWO-WHEELER",
  //     );

  //     setSelectedCategory(defaultCategory?.predefined_id ?? null);

  //     const twoWheelerIndex = categories.findIndex(
  //       (type: any) => type.code === "TWO-WHEELER",
  //     );
  //     if (twoWheelerIndex !== -1) {
  //       dispatch(setTabIndex(twoWheelerIndex));
  //     }

  //     return defaultCategory;
  //   }
  //   return null;
  // };
  const redirectToProducts = () => {
    navigate(`${basePath}products`, {
      state: {
        code,
        product_type_id: productType?.predefined_id,
        // category_ids: categoryId ? [categoryId] : [],
        category_ids: null,
      },
    });
  };

  const productListFunc = async (
    product_type: number,
    currentUserId?: any,
    silent: boolean = false,
    categoryOverride?: any,
  ) => {
    const thisRequestId = ++requestIdRef.current;
    if (!silent) {
      setProductLoading(true);
    }
    // setProductLoading(true);

    const payload: any = {
      page_size: 9,
      page_number: 1,
      user_id: currentUserId ?? userId ?? null,
      product_type_id: product_type,
    };

    if (entityType === "POPULAR" && code !== "ACCESSORIES") {
      payload.entity_type = "POPULAR";
    }
    const categoryToUse = categoryOverride ?? selectedCategory;
    if (categoryOverride == "ALL") {
    } else if (code === "ACCESSORIES") {
      payload.category_ids = categoryToUse ? [categoryToUse] : null;
    }
    try {
      const response: any = await getProductList(payload);
      if (thisRequestId !== requestIdRef.current) return;
      if (response?.status === 200 || response?.status === 201) {
        const raw = response?.data?.data || response?.data || [];
        setPopularProductsArray(raw.map(mapToProduct));
      }
    } catch (error) {
      console.error("Error fetching popular products:", error);
    } finally {
      // setProductLoading(false);
      if (thisRequestId === requestIdRef.current) {
        setProductLoading(false);
      }
    }
  };

  const fetchProductType = async () => {
    try {
      setLoader(true);
      const predefinedResponse = await predefinedFunc({
        entity_type: "PRODUCT-TYPE",
        code,
      });
      if (predefinedResponse.status === 200) {
        const allTypes = predefinedResponse?.data?.data || [];

        const productType =
          allTypes.find((p: any) => p?.code === code) ?? allTypes[0] ?? null;

        if (productType?.predefined_id) {
          setProductType(productType);
        }

        return productType;
      }
      return null;
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (!productType?.predefined_id) return;

    // Accessories requires category
    // if (code === "ACCESSORIES" && !selectedCategory) return;

    const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");

    const currentUserId = authTokens?.user?.id ?? null;

    productListFunc(
      productType.predefined_id,
      currentUserId,
      false,
      selectedCategory,
    );
  }, [refreshTrigger, productType?.predefined_id, selectedCategory, code]);

  useEffect(() => {
    const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");
    const currentUserId = authTokens?.user?.id ?? null;
    if (currentUserId) {
      setUserId(currentUserId);
    }

    (async () => {
      // const [category, pType] = await Promise.all([
      //   fetchPredefined(),
      //   fetchProductType(),
      // ]);
      const pType = await fetchProductType();

      // Then fetch predefined/category
      const category = await fetchPredefined(pType?.predefined_id);

      if (pType?.predefined_id) {
        productListFunc(pType.predefined_id, currentUserId, false, category);
      }

      setLoader(false);
    })();
  }, [code]);

  return (
    <section className={styles.popularProductsSection}>
      <div>
        <div className={styles.headerRow}>
          <h2
            className={styles.sectionTitle && styles.title}
            style={{ marginBottom: "15px" }}
          >
            {title}
          </h2>

          {showViewAll && code !== "ACCESSORIES" && (
            <button className={styles.viewAllBtn} onClick={redirectToProducts}>
              View All <MdArrowForward size={16} />
            </button>
          )}
        </div>
        {loader ? (
          <AppSkeleton
            count={8}
            width="300px"
            height="300px"
            borderRadius="12px"
            containerClassName="popular-brands-skeleton-grid"
            className="popular-brands-skeleton-item"
          />
        ) : (
          <div className={styles.filterBar}>
            {/* {code === "ACCESSORIES" && */}
            {/* typesPreDefinedState.map((item: any) => ( */}
            {/* <button
                 key={item?.predefined_id}
                 className={`${styles.chip} ${selectedCategory === item?.predefined_id
                     ? styles.chipActive
                     : ""
                   }`}
                 onClick={() => setSelectedCategory(item?.predefined_id)}
               > */}
            {/* <img
                 src={item?.url ? item.url : carStand}
                 alt={item?.name || item?.code}
                 className={styles.categoryIcon}
               /> */}
            {/* <span className="text">{item?.name || item?.code}</span>
               </button> */}
            {/* ))} */}

            {code === "ACCESSORIES" && (
              <>
                {/* ALL button */}
                <button
                  className={`${styles.chip} ${
                    selectedCategory === null ? styles.chipActive : ""
                  }`}
                  onClick={() => setSelectedCategory(null)}
                >
                  <span className="text">ALL</span>
                </button>

                {/* Categories */}
                {typesPreDefinedState.map((item: any) => (
                  <button
                    key={item?.predefined_id}
                    className={`${styles.chip} ${
                      selectedCategory === item?.predefined_id
                        ? styles.chipActive
                        : ""
                    }`}
                    onClick={() => setSelectedCategory(item?.predefined_id)}
                  >
                    <span className="text">{item?.name || item?.code}</span>
                  </button>
                ))}
              </>
            )}
          </div>
        )}
      </div>

      {productLoading ? (
        <AppSkeleton
          count={8}
          width="300px"
          height="300px"
          borderRadius="12px"
          containerClassName="popular-brands-skeleton-grid"
          className="popular-brands-skeleton-item"
        />
      ) : (
        <ProductGrid products={popularProductsArray} code={code} />
      )}
    </section>
  );
}
